// @flow

import React from 'react';
import { ACFPdbCTA } from '@leasen_nl/listo/src/components/pdbCallToAction';

export default () => (<ACFPdbCTA />);
